export function minutesBetween(start: Date, end: Date): number {
  return Math.max(0, (end.getTime() - start.getTime()) / 60_000);
}

export function getOverlapMinutes(
  aStart: Date,
  aEnd: Date,
  bStart: Date,
  bEnd: Date
): number {
  const overlapStart = new Date(Math.max(aStart.getTime(), bStart.getTime()));
  const overlapEnd = new Date(Math.min(aEnd.getTime(), bEnd.getTime()));
  return Math.max(0, minutesBetween(overlapStart, overlapEnd));
}
